import {PostSiteRequestDto} from './PostSiteRequestDto';

export class PostImportCustomerRequestDto {
    name: string;
    crmId: number;
    categoryId: number;
    site: PostSiteRequestDto;
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/models/PostImportCustomerRequestDto.ts